__webpack_require__.p = "https://www.ikea.com/at/de/purchase-agent/cart-tmp/";